// utils/validation.js

/**
 * Reglas de validación reutilizables
 */
export const validationRules = {
  required: (value) => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return 'Este campo es requerido';
    }
    return null;
  },
  
  email: (value) => {
    if (!value) return null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Email inválido';
    }
    return null;
  },
  
  minLength: (min) => (value) => {
    if (!value) return null;
    if (value.length < min) {
      return `Mínimo ${min} caracteres`;
    }
    return null;
  },
  
  maxLength: (max) => (value) => {
    if (!value) return null;
    if (value.length > max) {
      return `Máximo ${max} caracteres`;
    }
    return null;
  },
  
  number: (value) => {
    if (!value) return null;
    if (isNaN(value)) {
      return 'Debe ser un número';
    }
    return null;
  },
  
  positiveNumber: (value) => {
    if (!value) return null;
    if (isNaN(value) || parseFloat(value) < 0) {
      return 'Debe ser un número positivo';
    }
    return null;
  },
  
  phone: (value) => {
    if (!value) return null;
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    if (!phoneRegex.test(value.replace(/[\s()-]/g, ''))) {
      return 'Teléfono inválido';
    }
    return null;
  },
  
  combine: (...rules) => (value) => {
    for (const rule of rules) {
      const error = rule(value);
      if (error) return error;
    }
    return null;
  }
};